import * as React from 'react';
import Typography from '@mui/material/Typography';

const HeaderText = ({ children }) => (
  <Typography component="h2" variant="h2">
    { children }
  </Typography>
);

export default HeaderText;